<template>
  <div>
    <p v-if="p_title" class="pTtl" @click="p11_sltTb">
      {{ p_title }}
      <b v-show="bbView">◢</b><!--∧∨▼▲△▽▶▷-->
      <b v-show="!bbView">▶</b>
    </p>
    <div v-show="bbView" class="divList" style="height:50px;border:1px solid gray;">
      <table style="width:98%;" class="tbList">
        <thead>
          <tr class="editTbHead">
            <th style="width:1%;max-width: 30px;min-width: 25px;"/>
            <th v-for="(row,idx) in p_colm" :key="idx">{{ row.vlabel }}</th>
            <th style="width:4%;max-width: 60px;min-width: 40px;"/>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row,idx) in p_list" :key="idx">
            <td>{{ idx+1 }}</td>
            <td
              v-for="(mm,eidx) in p_colm"
              :key="eidx"
              :class="mm.vread?'':'tdEdit'"
              :style="[{'width':mm.vwidth+'%'}]"
            ><!--@mouseover="p27_eHover(row)"-->
              <!---{{ mm.vvtype }} {{ mm.vkey }}--->
              <p v-if="mm.vread">
                <a :class="mm.vvtype==13?'aBlue':'aGray'" @click="eClick(row,mm)">{{ row[mm.vkey] }}</a>
              </p>
              <div v-if="!mm.vread">
                <div v-if="mm.vchg">
                  <input v-if="!mm.vvtype||mm.vvtype===6" v-model="row[mm.vkey]" @change="eChg(mm.vchg,row)">
                  <input v-if="comm.numIn(mm.vvtype,[1,9])" v-model="row[mm.vkey]" type="number" @change="eChg(mm.vchg,row)">
                </div>
                <div v-if="!mm.vchg">
                  <input v-if="!mm.vvtype||mm.vvtype===6" v-model="row[mm.vkey]">
                  <input v-if="comm.numIn(mm.vvtype,[1,9]) && !mm.vchg" v-model="row[mm.vkey]" type="number">
                </div>
                <el-date-picker
                  v-if="mm.vvtype===3"
                  v-model="row[mm.vkey]"
                  :clearable="false"
                  size="mini"
                  type="date"
                  value-format="yyyy-MM-dd"
                />
                <input v-if="mm.vvtype===4" v-model="row[mm.vpkey]">
                <input v-if="mm.vvtype===5" v-model="row[mm.vpkey]" type="hidden">
                <input
                  v-if="mm.vvtype===5"
                  v-model="row[mm.vkey]"
                  type="text"
                  @click="p17_toPicker(mm,idx)">

                <input v-if="mm.vvtype===8" v-model="row[mm.vkey]" type="checkbox">
              </div>
            </td>
            <td class="tdAct"><!---
            <b @click="addRow(idx)">─</b>
            <b @click="addRow(idx,true)">+</b>--->
            </td><!---↔✖✖✚━ ╋┼─--->
          </tr>
        </tbody>
      <!--
        <tfoot>
        <tr class="editTbFoot">
          <th/>
          <th v-for="(row,idx) in p_colm" :key="idx"/>
          <th/>
        </tr>
      </tfoot>
      -->
      </table>
    </div>
  </div>
</template>
<script>
import './../../../static/c_div.css'
import './../../../static/c_table.css'
export default {
  name: 'ITable',
  props: {
    p_title: {
      type: String,
      default: ''
    },
    p_colm: {
      type: Array,
      default: () => {
        return []
      }
    },
    p_list: {
      type: Array,
      default: () => {
        return []
      }
    },
    a_do: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      bbView: true
    }
  },
  computed: {
  },
  watch: {
    p_list: {
      handler(newV, oldV) {
      },
      immediate: true
    }
  },
  activiated: () => {},
  mounted: () => {},
  created: () => {},
  methods: {
    prt(a, b) {
      console.log(`c07_table.${a}`, b)
    },
    p11_sltTb() {
      this.bbView = !this.bbView
    },
    eClick(row, mm) {
      // link to file
      if (mm.vvtype === 13) {
        const path = row.fidmenu + '/' + row.fidparent + '/' + row.fpath
        const url = this.$keys().mainUrl + '/login/down?name=' + row.filenm + '&path=' + path
        this.prt('eClick.url.3', url)
        this.$dnFile(url, row.fname + '.' + row.filenm)
        /*
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', row.fname + '.' + row.filenm)
        link.click()*/
        // window.open(url, 'blank') // http://127.0.0.1:10091/11002/1/eventlog/EL_20240614.evt
      }
    }
  }
}
</script>
<style scoped>
.aBlue{
  color:blue;
}
.aGray{
  color:grey;
}
</style>



// WEBPACK FOOTER //
// src/comps/c3_tools/07_table.vue